module.exports = __webpack_public_path__ + "static/media/news2.703859f3.jpg";